import Dialog from "./dialog";
import "jquery-sticky";
import initPhotoSwipeFromDOM from "./pswp-utils";
import WcQuantity from "./wc_quantity";
import Cookies from "./cookies";
import Utils from "./utils";
import Edrone from './edrone';
import Register from './register';

window.breakpoints = {
    xlarge: 1200,
    large: 1024,
    medium: 720,
    small: 320
};

window.Dialog = Dialog;

(function ($, root, undefined) {
    $(document).on('signup', function (e) {

        let emails = e.mail;

        Edrone.push(function (_edrone) {
            emails.forEach(function (address) {
                if (typeof _edrone != 'undefined') {

                    _edrone.action_type = 'subscribe';
                    _edrone.email = address;
                    _edrone.subscriber_status = '1';
                    _edrone.init();
                }
            });
        });

    });
    $(document).ready(function () {
        if (window.location.hash) {
            var scroll = function() {
                var hash = window.location.hash.match(/^\#(?:[a-zA-Z]+_)(\d+)/);
                hash = (typeof hash == 'object') ? hash[1] : window.location.hash.substring(1);
                var $navWrap = $('.nav-wrap.header-nav'),
                    $target = $(`#product_${hash}`),
                    $prod = $(`[data-product_id='${hash}']`);

                if (!$target.length) {
                    $target = $prod;
                } else if (!$target.length) {
                    return;
                }

                $('html, body').animate({
                    scrollTop: $target.offset().top - $navWrap.height() - 90
                }, 500);
            }
            scroll();
            $(window).load(scroll);

        }

        $(".user_nav .toggle").click(function (ev) {
            ev.stopPropagation();
            $(".user_nav__popup").toggleClass("is-active");
        })

        $("body").on("click", ".switcher button", function (ev) {
            var id = $(this).data("for");
            $(".switcher_content").not("#" + id).hide();
            $(".switcher_content#" + id).show();
            $(".switcher button").removeClass("active");
            $(this).addClass("active");

        });
        //Ladda.bind('.ladda-button');
        $(".footer .nav_left .menu>.menu-item>a").click(function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
        });
        initPhotoSwipeFromDOM('.pswp-gallery');


        $(".account-form").on('submit', function (ev) {

            console.log(ev);
            var form = ev.delegateTarget;
            Utils.putSpinnerOn($(form));

            var $err_wrap = $(form).find('.error_wrap');
            $err_wrap.text('');
            Utils.fetchJson(form.getAttribute('action'), new FormData(ev.delegateTarget), "POST").then((json) => {
                console.log(json);
                Utils.disableSpinner();
                if (json.status != 'success') {
                    console.log(json.errors)
                    for (let i = 0; i < json.errors.length; i++) {
                        const e = json.errors[i];

                        if (e.invalid_email || e.incorrect_email) {
                            var message = e.incorrect_email ? e.incorrect_email : e.invalid_email;
                            $(form).find('#register_error_reg_email').text(message);

                        }
                        if (e.reg_email) {
                            form.querySelector(`#register_error_reg_email`).innerHTML = e.reg_email;
                        }
                        if (e.invalid_password || e.incorrect_password) {
                            form.querySelector(`#register_error_reg_password`).innerHTML = e.incorrect_password ? e.incorrect_password : e.invalid_password;
                        }
                        if (e.terms) {
                            form.querySelector(`#register_error_terms`).innerHTML = e.terms;
                        }
                    }
                } else {
                    window.location.href = json.redirect;
                }
            });
            ev.preventDefault();
        });
        /* //HACK// */
        $(".wsafp-form .button").removeClass("button").addClass("bg_red ghost_button");

        //
        $(".open_cart").click(function (ev) {
            if ($(".nav_cart__counter").hasClass("is-empty")) {

                var dlg = new Dialog(empty_cart_popup);
                dlg.toggle();
                //$("#somedialog").attr("notice-popup","true");
                //dlg.setBody();
                ev.stopPropagation();
                ev.preventDefault();
                return false;
            }
        });
    });
    $(function () {
        if (window.matchMedia("(min-width: 769px)").matches) {

            let $cart = $(".sticky_cart"),
                bottomSpacing;
            if ($cart.is('.mini_cart')) {

                let $cat = $('.categories_row');
                bottomSpacing = $(document).height() - ($cat.height() + $cat.offset().top);

            } else {
                bottomSpacing = $(".footer_wrap").outerHeight();
            }

            $cart.sticky({
                topSpacing: 110,
                bottomSpacing: bottomSpacing + 30
            });

        }
    });

    $(".language_chooser").click(function (ev) {
        if ($(ev.target).parent().closest('.language_chooser__popup').length > 0) {
            return;
        }
        $(".language_chooser").toggleClass("active");
    });
    $("#contact_person_check").change(function () {
        $(".contact_person_fields").toggleClass("hidden");
    });
    $(".vc_toggle").click(function () {
        if ($(this).hasClass("vc_toggle_active")) {
            $(this).removeClass("vc_toggle_rotate_arrow");
        } else {
            $(this).addClass("vc_toggle_rotate_arrow");
        }
    });
    $(document.body).on("added_to_cart", function () {
        checkCartIsEmpty();
    });
    $(".menu-toggle").click(function () {
        $(this).find(".hamburger").toggleClass("is-active");
        $(".menu").toggleClass("is-active");
        $("body").toggleClass("menu-open");

    });
    $("body").on("click", ".open_product_popup", function (ev) {
        ev.stopPropagation();
        ev.preventDefault();

        var dlg = new Dialog(somedialog);
        dlg.toggle();
        $("#somedialog").addClass("is-empty");
        $("#somedialog .dialog__content__body").html("");
        var pid = $(this).data("product_id");
        $.post(backend.ajax, {
            action: 'get_product_popup',
            product_id: pid
        }, function (response) {
            $("#somedialog").removeClass("is-empty");
            dlg.setBody(response);
        });
    });
    var $dialogs = $(".dialog.open-now");
    for (var i = 0; i < $dialogs.length; ++i) {
        var dlg = new Dialog($dialogs[i]);
    }
    $(".wc_quantity").each(function () {
        var self = this;
        new WcQuantity(this);
    });
    $("#do_company").change(function () {
        if ($(this).prop('checked')) {
            $("body").addClass("do_company");
            $(".company_fields__inner input").removeAttr("disabled");
        } else {
            $("body").removeClass("do_company");
            $(".company_fields__inner input").attr("disabled", "disabled");
        }
    });

    $("a.product_less").on('click', function (ev) {
        var $thisbutton = $(this);
        if (!$thisbutton.attr('data-product_id')) {
            return true;
        }

        $thisbutton.removeClass('added');
        $thisbutton.addClass('loading');

        var data = {};

        $.each($thisbutton.data(), function (key, value) {
            data[key] = value;
        });
        // Trigger event
        $(document.body).trigger('adding_to_cart', [$thisbutton, data]);

        ev.stopPropagation();
        ev.preventDefault();
        $.post(backend.decrement_quantity, {
            action: 'decrement_quantity',
            product_id: $(this).attr("data-product_id")
        }, function (response) {

            console.log(response);
            if (!response) {
                return;
            }

            var this_page = window.location.toString();

            this_page = this_page.replace('add-to-cart', 'added-to-cart');

            if (response.error && response.product_url) {
                window.location = response.product_url;
                return;
            }

            // Redirect to cart option
            if (wc_add_to_cart_params.cart_redirect_after_add === 'yes') {

                window.location = wc_add_to_cart_params.cart_url;
                return;

            } else {

                $thisbutton.removeClass('loading');

                var fragments = response.fragments;
                var cart_hash = response.cart_hash;

                // Block fragments class
                if (fragments) {
                    $.each(fragments, function (key) {
                        $(key).addClass('updating');
                    });
                }

                // Block widgets and fragments
                $('.shop_table.cart, .updating, .cart_totals').fadeTo('400', '0.6').block({
                    message: null,
                    overlayCSS: {
                        opacity: 0.6
                    }
                });

                // Changes button classes
                $thisbutton.addClass('added');

                // View cart text
                if (!wc_add_to_cart_params.is_cart && $thisbutton.parent().find('.added_to_cart').size() === 0) {
                    $thisbutton.after(' <a href="' + wc_add_to_cart_params.cart_url + '" class="added_to_cart wc-forward" title="' +
                        wc_add_to_cart_params.i18n_view_cart + '">' + wc_add_to_cart_params.i18n_view_cart + '</a>');
                }

                replaceFragments(fragments);
                // Unblock
                $('.widget_shopping_cart, .updating').stop(true).css('opacity', '1').unblock();

                // Cart page elements
                $('.shop_table.cart').load(this_page + ' .shop_table.cart:eq(0) > *', function () {

                    $('.shop_table.cart').stop(true).css('opacity', '1').unblock();

                    $(document.body).trigger('cart_page_refreshed');
                });

                $('.cart_totals').load(this_page + ' .cart_totals:eq(0) > *', function () {
                    $('.cart_totals').stop(true).css('opacity', '1').unblock();
                });

                // Trigger event so themes can refresh other areas
                $(document.body).trigger('added_to_cart', [fragments, cart_hash, $thisbutton]);
            }
        });

    });

    var getQueryString = function (str) {
        str = str.substr(str.indexOf('?') + 1);
        return (str || document.location.search).replace(/(^\?)/, '').split("&").map(function (n) {
            return n = n.split("="), this[n[0]] = n[1], this
        }.bind({}))[0];
    }

    $("body").on("click", ".mini_cart_item .remove", function (ev) {
        var url = $(this).attr("href");
        ev.preventDefault();
        ev.stopPropagation();
        var data = {
            action: 'remove_from_cart'
        };
        data = $.extend(data, getQueryString(url));
        console.log(data);
        $.post(backend.decrement_quantity, data, function (response) {

            var fragments = response.fragments;
            var cart_hash = response.cart_hash;
            var $thisbutton = $(this);
            replaceFragments(fragments);
            // Trigger event so themes can refresh other areas
            $(document.body).trigger('added_to_cart', [fragments, cart_hash, $thisbutton]);
        });
    });
    function replaceFragments(fragments) {
        // Replace fragments
        if (fragments) {
            $.each(fragments, function (key, value) {
                $(key).replaceWith(value);
            });
        }
    }

})(jQuery, this);



// WEBPACK FOOTER //
// ./assets/js/common.js